import { FC, lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { ThrowNotFound } from 'src/components/not-found';
import {
  LayoutContainer,
  LayoutContent,
  LayoutSidebar,
} from 'src/components/sidebar';
import { PageSpinner } from 'src/components/spinner-container';
import { RegistrationSettingsSidebar } from 'src/pages/settings/registration/sidebar';
import { useSettings } from 'src/pages/settings/registration/use-settings';

const Registration = lazy(() => import('./page'));

export const RegistrationSettings: FC = () => {
  const settings = useSettings();

  if (!settings.response) return <PageSpinner />;

  return (
    <LayoutContainer>
      <LayoutSidebar>
        <RegistrationSettingsSidebar settings={settings.response} />
      </LayoutSidebar>

      <Switch>
        <Route path="/settings/registration">
          <Registration />
        </Route>

        <Route>
          <LayoutContent>
            <ThrowNotFound />
          </LayoutContent>
        </Route>
      </Switch>
    </LayoutContainer>
  );
};
